var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');

var mod = Object.create(Model);

mod.name = 'Dataset';
mod['@class'] =  'Dataset'
mod.url = 'dataset'

mod.initForm = function (record, options) {
  var self = this;
  self.record = record || {};
  self.form = {};
  if (typeof self.record.extendedProps === 'undefined') {
    self.record.extendedProps = {};
  }
  self.errors = [];
  self.successes = [];
  self.fields = {};
  self.property = options.property || 0;

  self.fields[self.property] = {
    default: 0,
    validators: {},
    type: 'number'
  };

  self.form[self.property] = prop(self.record.extendedProps[self.property]);
};

mod.save = function () {
  var self = this;
  var data = {};
  var extendedProps = {}
  var propertyString = self.property;
  var propertyValue = self.form[self.property]();
  
  if (Object.keys(self.record.extendedProps).length == 0) {
    extendedProps[propertyString] = propertyValue;
    data.extendedProps = extendedProps;
  } else {
    data = {"extendedProps": {  }}
    data["extendedProps"][propertyString] = propertyValue;
  }

  return loaders.requestWithLoader({
    loader: 'submit',
    url: self.getUrl(self.record),
    method:'PUT',
    body: data
  })
  .then(function (result) {
    self.record.extendedProps[propertyString] = propertyValue;
    return result;
  })
}


module.exports = mod;
